<script setup lang="ts">
import Icon from '~/assets/images/icons/backspace.svg'

defineProps<{
  size: number
}>()
</script>

<template>
  <Icon fill="#000" :height="size" :width="size" />
</template>
